// Melding op het bord als het gezinsbord verwijderd gaat worden (0036; docs/DESIGN.md §8.PR.5).
// Rustig en voor iedereen leesbaar, ook voor kinderen: geen knop (tegenhouden kan alleen de
// eigenaar in de app), geen woorden als "gegevens wissen".
export const kioskPrivacyNl = {
    closingTitle: 'Dit bord stopt op {date}',
    closingBody: 'Klopt dat niet? Vraag het aan een ouder: in de app kan het nog tegengehouden worden.',
};
//# sourceMappingURL=kioskPrivacy.nl.js.map